module.exports = __webpack_public_path__ + "fc1caad4139f764993b367547a5fb464.woff2";